import {Timestamps} from '../../../global'

export type WpTypes = 'wp' | 'theme' | 'plugin'
export interface WPItem extends Timestamps {
  type: WpTypes;
  name: string;
  slug: string;
  oldVersion: string;
  newVersion: string;
}



export interface WPData {
  wp: WPItem[];
  theme: WPItem[];
  plugin: WPItem[];
}

export const initialWPData: WPData = {
  wp: [],
  theme: [],
  plugin: []
};